module.exports = "<div data-component=\"block-preloader\">\n\t<mat-spinner></mat-spinner>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/block-preloader/block-preloader.component.html
// module id = ../../../../../src/app/shared/block-preloader/block-preloader.component.html
// module chunks = main